import React from 'react'
import logo from '../images/logo.svg'

const  Logo = ()=> {
    return (
        <div>
            <img className="logo" src={logo} alt="logo-burger-queen"/>
        </div>
    )
}

export default Logo;